const DEBUGGING: boolean = process.env.NODE_ENV === 'development'

import { BaseObject, MongoObject } from './_baseClasses'
import { Account } from './Account';
import { AuctionListing } from './AuctionListing';
import * as telegram from "./telegram"
import * as utils from "./utils"
import { Auction, auctionStatus } from './Auction';

export class MyAuctions extends BaseObject {
  public account: Account = null
  public moments: AuctionListing[] = null
  public numMoments: number = null
  public computedDate: Date = null

  // complex, class-based fields (require to be hydrated after loading from external sources like mongo or elastic)

  constructor(po?: object, account?: Account) {
    super()
    if (po) this.injectPlainObject(po)
    if (account) this.account = account
    this.hydrate()
  }

  protected hydrate(): void {
    super.hydrate()
    if (this.account) this.account = new Account(this.account)
    // @ts-ignore
    if (this.moments) this.moments = this.moments.map((po) => new AuctionListing(po))
    if (typeof this.computedDate === 'string') this.computedDate = new Date(this.computedDate)
  }

  public isSafe(): boolean {
    return true
  }



}




(async () => {
})();
